// Single source of truth for the menu currency. Switch to your locale here.
export const CURRENCY_SYMBOL = '₹';
export const CURRENCY_LOCALE = 'en-IN';

/**
 * Format a numeric price with the configured currency symbol and locale.
 * Examples (en-IN, ₹):
 *   formatCurrency(120)       => "₹120.00"
 *   formatCurrency(1250.5)    => "₹1,250.50"
 *   formatCurrency(null)      => ""
 */
export const formatCurrency = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '';
  const num = Number(n);
  const formatted = num.toLocaleString(CURRENCY_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${CURRENCY_SYMBOL}${formatted}`;
};
